import styled from 'styled-components';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 12px;
	gap: 0px;
	border-radius: 8px;
`;
